const styles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 0
  })
}

export default styles
